module.exports = __webpack_public_path__ + "img/mission-icon-3.b4663122.png";